
<div mat-dialog-content>
    Are you sure you want to do this?
</div>
<div mat-dialog-actions [align]="'end'">
  <button mat-raised-button [mat-dialog-close]="false">No</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true">Yes</button>
</div>
